<template>
  <div class="page-container">
    <!-- 主体容器 -->
    <div class="main-container">
      <!-- 模块：电价维护（同现货电价卡片结构） -->
      <section class="maint-card">
        <div class="maint-card__header">
          <div class="title-container">
            <span class="symbol-icon"></span>
            <span class="title-text">{{ $str.getKey('收益管理/电价维护') }}</span>
          </div>
          <div class="btns-container">
            <el-form class="form-container" label-position="left" :model="formData">
              <el-form-item class="query-item query-item--area" :label="$str.getKey('收益管理/地区')">
                <el-cascader v-model="formData.adCode" :options="adOptions" @change="handleAdChange" :props="formData.cascaderProps" :show-all-levels="false" clearable />
              </el-form-item>
              <el-form-item class="query-item query-item--date" :label="$str.getKey('收益管理/日期')">
                <el-date-picker
                  v-if="formData.priceType === 'spot'"
                  v-model="formData.spotDate"
                  type="date"
                  value-format="YYYY-MM-DD"
                  :clearable="true"
                  :placeholder="$str.getKey('收益管理/请选择')"
                  @change="timeRangeChange"
                  :disabled-date="disabledDate"
                />
                <el-date-picker
                  v-else
                  v-model="formData.month"
                  type="month"
                  :clearable="true"
                  :placeholder="$str.getKey('收益管理/请选择')"
                  @change="timeRangeChange"
                  :disabled-date="disabledDate"
                />
              </el-form-item>
              <el-form-item class="query-item query-item--type" :label="$str.getKey('收益管理/电价类型')">
                <el-select
                  v-model="formData.priceType"
                  class="price-type-select"
                  clearable
                  :placeholder="$str.getKey('收益管理/请选择')"
                  @change="handlePriceTypeChange"
                >
                  <el-option label="代理购电" value="proxy" />
                  <el-option label="充电桩" value="chargePile" />
                </el-select>
              </el-form-item>
              <el-form-item class="query-item query-item--action" label="">
                <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="handlePrimaryAction">
                  {{ formData.priceType === 'spot' ? $str.getKey('收益管理/查询') : $str.getKey('收益管理/录入电价') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="maint-card__body">
          <div v-if="formData.priceType === 'spot'" class="spot-list-container">
            <SpotPriceListOnly ref="spotListRef" :area-code="formData.adCode" :price-date="formData.spotDate" :auto="false" />
          </div>
          <div v-else class="elecprice-container">
            <ElecDetailsPanel
              :origin-data="detailsOption"
              :business-price-type="priceTypeFromFormSelect()"
              @refresh="handleRefreshDetails"
            />
          </div>
        </div>
      </section>

      <!-- 容器：电价历史 -->
      <div class="history-section">
        <div class="history-container">
          <HistoryListPanel ref="historyPanel" :adOptions="adOptions" />
        </div>
      </div>

      <!-- 模块：各省现货历史电价 -->
      <div class="spot-history-section">
        <SpotHistoryListPanel :adOptions="adOptions" />
      </div>

    </div>

    <!-- 录入信息弹窗 -->
    <TypeInModal v-if="modalOption.isShow" v-model:show="modalOption.isShow" :adOptions="adOptions" @onClose="handleModalClose" />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue"
import dayjs from 'dayjs';
import { queryAdRegionInfo, queryElecPriceInfoForAd } from './api/index.js';
import TypeInModal from './typeInModal.vue';
import ElecDetailsPanel from './elecDetailsPanel.vue';
import HistoryListPanel from './historyListPanel.vue';
import SpotHistoryListPanel from './components/SpotHistoryListPanel.vue'
import SpotPriceListOnly from './components/SpotPriceListOnly.vue'

const $str = window.$str;

const historyPanel = ref(null); // 引用历史列表面板
const spotListRef = ref(null)
const loading = ref(false); // 控制加载中动效的渲染
const adOptions = ref([]); // 存储行政区域的下拉选项

// 表单对应的数据对象
const formData = reactive({
  cascaderProps: { // 级联配置对象
    checkStrictly: true,
    expandTrigger: 'hover',
    emitPath: false, // 只返回当前节点的值
  },
  adCode: '', // 示例：山东省-370000
  month: dayjs().format('YYYY-MM'),
  spotDate: dayjs().format('YYYY-MM-DD'),
  priceType: 'proxy',
})


// 用于和【录入电价弹窗】交互的配置对象
const modalOption = reactive({
  isShow: false,
})

// 用于和【电价详情面板】交互的配置对象
const detailsOption = reactive({
  tableData: [],
})

// 初始化页面
initPage();







/** ====== [业务：功能方法] =================================================================== */
/** 页面初始化 */
function initPage() {
  getAdRegionOptions();
  refreshDetailsPanel();
}

/** 设置日期的禁选范围 */
function disabledDate(date) {
  return false;
  // return date < dayjs().subtract(6, 'month').startOf('month');
  // return date > dayjs() || date < dayjs().subtract(6, 'month').startOf('month');
}

/** 事件响应：行政区域发生变化 */
function handleAdChange(adCode) {
  formData.adCode = adCode;
  if (formData.priceType === 'spot') {
    // 现货列表：不自动请求，保持用户点“查询”
    return
  }
  refreshDetailsPanel();
}

/** 响应选择月份发生变化 */
function timeRangeChange(value) {
  if (formData.priceType === 'spot') {
    return
  }
  refreshDetailsPanel();
}

function handlePriceTypeChange() {
  // 切换到现货时：不再请求图片/详情，避免无效接口
  if (formData.priceType !== 'spot') {
    refreshDetailsPanel()
  }
}

function handlePrimaryAction() {
  if (formData.priceType === 'spot') {
    spotListRef.value?.refresh?.()
    return
  }
  onTypeIn()
}


/** 打开录入电价弹窗 */
function onTypeIn() {
  modalOption.isShow = true;
}



/** 处理弹窗的关闭事件 */
function handleModalClose(needRefresh, priceInfo) {
  modalOption.isShow = false;

  // 关闭弹窗后，是否需要刷新页面数据
  if (needRefresh) {
    formData.adCode = priceInfo.adCode;
    formData.month = priceInfo.month;
    refreshDetailsPanel(); // 刷新详情面板
    historyPanel.value.refreshByParent(priceInfo); // 刷新历史数据
  }
}

/** 事件响应：详情面板编辑成功-刷新详情数据 */
function handleRefreshDetails() {
  refreshDetailsPanel();
}



/** ====== [辅助：功能方法] =================================================================== */

/** 获取行政区域的下拉选项 */
function getAdRegionOptions() {
  queryAdRegionInfo().then(res => {
    adOptions.value = formatCascaderOption(res?.data);
  })
}


/** 格式化行政区域下拉选项的数据结构 */
function formatCascaderOption(list) {
  if (Array.isArray(list)) {
    return list.map(item => {
      const newItem = {
        value: item.code,
        label: item.name,
        children: [],
      }
      if (Array.isArray(item.cityList)) {
        newItem.children = formatCascaderOption(item.cityList);
      }
      return newItem;
    })
  }
  console.error('接口返回的行政区域选项应为数组！')
  return [];
}


/** 页头「电价类型」与后端 priceType：1 代理购电；2 现货；3 充电桩 */
function priceTypeFromFormSelect() {
  // 最新约定：1 代理购电；2 充电桩；现货不传 priceType
  if (formData.priceType === 'chargePile') return 2
  return 1
}

/** 刷新电价详情面板 */
function refreshDetailsPanel() {
  if (formData.priceType === 'spot') return
  if (formData.adCode) {
    const params = {
      adCode: formData.adCode,
      priceType: priceTypeFromFormSelect(),
    }
    if (formData.month) {
      params['month'] = dayjs(formData.month).format('YYYY-MM');
    }
    queryElecPriceInfoForAd(params).then(res => {
      if (Array.isArray(res?.data)) {
        detailsOption.tableData = res.data.map(row => ({
          id: row.id,
          type: row.type, // 用电方式：0 单一制；1 两部制（非 industry）
          // industry 字典见 utils/priceEnum：0 一般工商业；1 大工业
          industryType: row.industryType ?? row.industry,
          systemType: row.systemType ?? row.type,
          adName: row.areaName, // 地区名称
          adCode: row.areaCode, // 地区行政编码
          month: dayjs(row.monthDate).format('YYYY-MM'), // 电价对应的月份
          voltageLevel: row.voltageLevel, // 电压等级 1kv，10kv，20kv，35kv，110kv, 220kv
          segmentInfo: {
            sharpPrice: row.sharpPrice, // 尖峰
            peakPrice: row.peakPrice, // 高峰
            flatPrice: row.flatPrice, // 平
            valleyPrice: row.valleyPrice, // 低谷
            deepValleyPrice: row.deepPrice, // 深谷
          },
          beEditing: false,
        }))
      }
    })
  }
}




</script>
<style lang="scss" scoped>
@import '../_shared/feature-button.scss';

.page-container {
  --header-hight: 50px;
  & {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: calc(100% - var(--page-top));
    /* 外层不做卡片：由内部模块卡片承载层级 */
    background: transparent;
    backdrop-filter: none;
    margin-top: var(--page-top);
  
    border-radius: 0;
    border: none;
    box-shadow: none;
  
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  /* 顶部筛选：label 与现货电价一致 */
  .maint-card :deep(.el-form-item__label) {
    font-size: 16px;
    color: rgba(46, 46, 46, 0.65);
    line-height: 1.3;
    margin-bottom: 0;
    padding: 0;
    padding-right: 8px;
    white-space: nowrap;
  }

  /* 表单规范：统一高度与对齐（参考图2） */
  .maint-card :deep(.el-form-item) {
    margin: 0;
    align-items: center;
  }

  .maint-card :deep(.el-form-item__label) {
    width: 60px;
    justify-content: flex-end;
    line-height: 40px;
  }

  .maint-card :deep(.el-form-item__content) {
    line-height: 40px;
    display: flex;
    align-items: center;
  }

  .maint-card :deep(.el-date-editor),
  .maint-card :deep(.el-cascader),
  .maint-card :deep(.el-select),
  .maint-card :deep(.el-input) {
    width: 100%;
    min-width: 0;
  }

  /* 电价类型：避免被 flex 挤压到显示不全 */
  .maint-card :deep(.price-type-select) {
    min-width: 140px;
  }

  .maint-card :deep(.price-type-select .el-select__wrapper) {
    min-width: 140px;
  }

  .maint-card :deep(.el-input__wrapper),
  .maint-card :deep(.el-select__wrapper),
  .maint-card :deep(.el-date-editor .el-input__wrapper),
  .maint-card :deep(.el-cascader .el-input__wrapper) {
    /* 对齐「电表读数」页控件（MeterData.vue） */
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    padding: 0 16px;
    min-height: 40px;
    height: 40px;
    align-items: center;
    transition: border-color 0.2s;
  }

  .maint-card :deep(.el-input__wrapper.is-focus),
  .maint-card :deep(.el-select__wrapper.is-focused),
  .maint-card :deep(.el-date-editor .el-input__wrapper.is-focus),
  .maint-card :deep(.el-cascader .el-input__wrapper.is-focus) {
    border-color: #3a68ff;
  }

  /* 按钮：统一使用 .meter-feature-btn（见 ../_shared/feature-button.scss） */

  .main-container {
    & {
      width: 100%;
      max-width: 100%;
      height: 100%;
      flex: 1;
      min-width: 0;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      gap: 14px;
      box-sizing: border-box;
    }

    > * {
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
    }

    .maint-card {
      contain: inline-size;
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.82);
      border: 1px solid rgba(0, 0, 0, 0.06);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .maint-card__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 14px;
      padding: 12px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      background: linear-gradient(180deg, rgba(58, 104, 255, 0.05) 0%, rgba(255, 255, 255, 0) 72%);
      min-height: 56px;
      box-sizing: border-box;
      overflow-x: hidden;
      flex-wrap: wrap;
    }

    .maint-card__header .title-container {
      display: flex;
      align-items: center;
      gap: 10px;
      min-width: 140px;
    }

    .maint-card__header .symbol-icon {
      width: 4px;
      height: 20px;
      background: #485e91;
      border-radius: 2px;
    }

    .maint-card__header .title-text {
      font-size: 16px;
      font-weight: 600;
      color: rgba(46, 46, 46, 0.88);
    }

    .maint-card__header .btns-container {
      flex: 1;
      min-width: 0;
      display: flex;
      justify-content: flex-end;
      max-width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
    }

    .maint-card__header .form-container {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
      width: auto;
      min-width: 0;
      max-width: 100%;
      margin-left: auto;
      flex: 1 1 620px;
      justify-content: flex-end;
    }

    .maint-card__header .form-container .query-item {
      flex: 0 0 auto;
      margin: 0;
    }

    .maint-card__header .form-container .query-item--area {
      flex: 1 1 260px;
      max-width: 320px;
    }

    .maint-card__header .form-container .query-item--date {
      flex: 1 1 240px;
      max-width: 280px;
    }

    .maint-card__header .form-container .query-item--type {
      flex: 1 1 220px;
      max-width: 260px;
    }

    .maint-card__header .form-container .query-item--area :deep(.el-cascader) {
      width: 100% !important;
    }

    .maint-card__header .form-container .query-item--date :deep(.el-date-editor) {
      width: 100% !important;
      height: 40px !important;
      display: inline-flex;
      align-items: center;
    }

    /* 三个筛选项统一垂直居中，避免日期项视觉下沉 */
    .maint-card__header .form-container .query-item--date :deep(.el-form-item__content) {
      display: flex;
      align-items: center;
      margin-top: 0 !important;
      transform: none;
    }

    .maint-card__header .form-container .query-item--date :deep(.el-date-editor),
    .maint-card__header .form-container .query-item--date :deep(.el-input__wrapper) {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .maint-card__header .form-container .query-item--date :deep(.el-date-editor .el-input__wrapper) {
      height: 40px !important;
      min-height: 40px !important;
      line-height: 40px !important;
    }

    .maint-card__header .form-container .query-item--date :deep(.el-input__inner) {
      width: 100%;
      text-align: left;
    }

    .maint-card__header .form-container .query-item--type :deep(.el-select) {
      width: 100% !important;
    }

    .maint-card__header .form-container .query-item--action {
      width: auto;
      margin-left: 4px;
    }

    .maint-card__header .form-container .query-item--action :deep(.el-form-item__label) {
      display: none;
      width: 0;
      padding: 0;
    }

    .maint-card__header .form-container .query-item--action :deep(.el-form-item__content) {
      display: flex;
      align-items: center;
      margin-left: 0 !important;
    }

    .maint-card__header .form-container :deep(.el-form-item__label) {
      width: 60px !important;
      min-width: 60px;
      height: 40px;
      line-height: 40px;
      margin: 0 !important;
      padding-right: 8px;
      font-size: 16px;
      box-sizing: border-box;
    }

    .maint-card__header .form-container :deep(.el-form-item__content) {
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      margin: 0 !important;
      box-sizing: border-box;
    }

    .maint-card__body {
      padding: 14px 16px 16px;
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    .spot-list-container {
      width: 100%;
      flex: 1;
      min-height: 360px;
    }

    /* 电价数据表格独占一行，横向拉满 */
    .elecprice-container {
      width: 100%;
      flex: 1;
      min-height: 360px;
      min-width: 0;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .elecprice-container :deep(.panel-container) {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    .history-container {
      width: 100%;
      min-height: 400px;
      padding: 0;
      border-radius: 0;
      background: transparent;
      border: none;
      box-shadow: none;
      box-sizing: border-box;
    }

    .history-section {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      contain: inline-size;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 14px;
      overflow-x: hidden;
    }

    .spot-history-section {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      contain: inline-size;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 14px;
      overflow-x: hidden;
    }

    /* 仅限制电价维护子模块，禁止子面板反向撑开整页宽度 */
    .history-section :deep(.panel-container),
    .history-section :deep(.main-container),
    .history-section :deep(.hist-card),
    .spot-history-section :deep(.spot-hist-card) {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box;
    }

    .history-section :deep(.hist-card__header),
    .spot-history-section :deep(.spot-hist-card__header) {
      overflow-x: hidden;
    }

    /* 模块级兜底：表格只在自身容器滚动，不得反向撑开整页 */
    :deep(.spot-table-wrap),
    :deep(.spot-table-inner),
    :deep(.ops-spot-table),
    :deep(.ops-spot-table .v-table__wrapper) {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box;
    }

    :deep(.ops-spot-table .v-table__wrapper) {
      overflow-x: auto !important;
      overflow-y: auto !important;
    }

    :deep(.ops-spot-table table) {
      width: 100% !important;
      max-width: 100% !important;
      table-layout: fixed !important;
    }
  }

}


</style>
